import { ContactPage } from 'src/pages'

const Contact = () => {
  return <ContactPage />
}

export default Contact
